import { render } from "./bmUpload.vue?vue&type=template&id=c006466a&scoped=true&lang=pug"
import script from "./bmUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./bmUpload.vue?vue&type=script&setup=true&lang=js"

import "./bmUpload.vue?vue&type=style&index=0&id=c006466a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c006466a"]])

export default __exports__